import { useCheckout } from '@/contexts/checkoutContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import { useEffect, useRef } from 'react';

export const useBeginCheckout = () => {
  const {
    checkoutData: { items },
  } = useCheckout();
  const { beginCheckout } = useDataLayer();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current || !items?.length) {
      return;
    }
    firedRef.current = true;
    beginCheckout(items);
  }, [items, beginCheckout]);
};
